import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Modal component that displays the privacy policy (tietosuojaseloste).
 * Content will be added by the user.
 */
@Component({
	selector: 'app-privacy-policy-modal',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './privacy-policy-modal.component.html',
	styleUrl: './privacy-policy-modal.component.scss',
})
export class PrivacyPolicyModalComponent {
	constructor(public activeModal: NgbActiveModal) {}
}
